import React from 'react'
import {Link} from 'react-router-dom';
import ScrollToTop from "react-scroll-to-top";
import Navbar from '../inc/Navbar';
import Product from './Product';
function Productpage() {
  return (
    <div>
               <Navbar/>
            <br/>
            <br/>
            <br/>
            
   
         
            <ScrollToTop smooth top="100" color="grey"/>

            <div className='cctvfotageberhampore'>
            <div className="album py-1">
                <div className="container mt-4">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Products</li>
                        </ol>
                    </nav>
                </div>
            </div>
            </div>
               <div className="album py-1">
                       <div className="container">
                    <h1 className='mt-0' style={{color:"#081451"}}><b>Our Products</b></h1>
                    </div>
                </div>
            <Product/>
            <br/>

    </div>
  )
}

export default Productpage